import {UmpireStatisticValues} from '../umpire-statistic-values';

export interface UmpirePlayerStats {
  squad_player_id: string;

  squad_player_match_stats: UmpireStatisticValues;
}
